import Slider from "./slider";
import { disableVideo, enableVideo } from "../utils/video";

export default function (el) {
    const swiper = Slider(el);
    const tabs = el.querySelectorAll(".ht__tab");

    const changeTabState = (index, actionType) => {
        tabs[index] && tabs[index].classList[actionType]("btn-bounded--active");

        if(actionType === "remove") disableVideo(swiper.slides[index]);
        if(actionType === "add") enableVideo(swiper.slides[index]);
    }

    if(!swiper || tabs.length === 0) return;

    changeTabState(swiper.realIndex, "add");

    swiper.on("slideChange", () => {
        changeTabState(swiper.previousIndex, "remove");
        changeTabState(swiper.realIndex, "add");
    });

    tabs.forEach((tab, index) => tab.addEventListener("click", () => swiper.slideTo(index)));
}